/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

/**
 * @description Affichage du loyer d\'une location :\n- CHARGES_INCLUDED : charges comprises (CC)\n- CHARGES_EXCLUDED : hors charges (HC)\n
 */
export const propertyRentDisplaySchema = z.enum(["CHARGES_INCLUDED", "CHARGES_EXCLUDED"]).describe("Affichage du loyer d'une location :\n- CHARGES_INCLUDED : charges comprises (CC)\n- CHARGES_EXCLUDED : hors charges (HC)\n")